export enum MessageRole {
  User = 'user',
  Bot = 'bot',
  System = 'system'
}

export interface ChatMessage {
  id: string;
  content: string;
  role: MessageRole;
  timestamp: string;
  imageUrl?: string | null; // 선택: 메세지에 표시할 이미지 URL (null 값 허용)
}